﻿import React from 'react';
import { isEmpty } from 'lodash';

import styleVars_1 from "styles/colors.module.scss";
const { white01, turquoise01  } = styleVars_1;;
import { CloseIcon } from 'components/Icon';

import { useComposeMessage } from './ComposeMessage';

import theme from "./AttachmentPreview.module.sass";

const AttachmentPreview = () => {
  const {
    attachment,
    setAttachment,
    setMessagePlaceholder,
  } = useComposeMessage();
  if (isEmpty(attachment)) {
    return null;
  }
  return (
    <div className={theme.AttachmentPreview}>
      <CloseIcon
        className={theme.CloseAttachment}
        fill={white01}
        width="32"
        height="32"
        style={{
          backgroundColor: turquoise01,
        }}
        onClick={() => {
          setAttachment({});
          setMessagePlaceholder('Start the conversation here');
        }}
      />
      <img className={theme.ImagePreview} src={attachment.preview} />
    </div>
  );
};

export default AttachmentPreview;
